var map = {
	"./logo.svg": 20,
	"./thumb_angularJSListaTarefas.jpg": 45,
	"./thumb_breakout.jpg": 46,
	"./thumb_flappyBird.jpg": 47,
	"./thumb_jsListaCompras.jpg": 48,
	"./thumb_leccor.jpg": 49,
	"./thumb_spaceGame.jpg": 50,
	"./thumb_tetris.jpg": 51,
	"./thumb_verdegente.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;